import {signOut} from 'aws-amplify/auth';
import {config} from '../config/amplify/auth';

// FNP-1685: a bare signOut() REJECTS on every deployed stage. Amplify clears the
// tokens first, then refuses the logout redirect because redirectSignOut is the
// portal, a different origin (InvalidOriginException). Naming this stage's
// portal as the preferred redirect makes Amplify send the browser through the
// broker's /logout to the portal; it sets window.location itself and resolves.
// signOut() also resolves WITHOUT navigating when there is no OAuth session, so
// the timer covers that case. A slow broker /logout may not have unloaded the
// page when the timer fires, so `beforeunload` marks a navigation already under
// way and the timer then leaves it alone (D14c). No `finally`: it would
// override Amplify's navigation.
export const signOutToPortal = async () => {
    const redirectUrl = config?.Cognito.loginWith?.oauth?.redirectSignOut[0];
    let leaving = false;
    const onLeave = () => {
        leaving = true;
    };
    window.addEventListener('beforeunload', onLeave);
    try {
        await signOut({global: false, oauth: {redirectUrl}});
        setTimeout(() => {
            if (!leaving) {
                window.location.href = '/';
            }
        }, 3000);
    } catch (error) {
        console.error('Sign out did not complete cleanly', error);
        window.location.href = '/';
    }
};
